// ESM-Konvertierung von lib/scripts/CLS_CTools.js (Phase 4, Welle 1a).
export class CTools {
  // Eltern-Komponenten-ID aus einem bereits gesplitteten Doppelpunkt-Pfad
  // (["0","3","5"] -> "0:3"); mutiert das uebergebene Array wie das Original.
  parseParentId(id, seperator) {
    id.pop();
    let parentId = id.toString();
    while (parentId.search(",") != -1)
      parentId = parentId.replace(/,/, ":");
    return parentId;
  }
}
